// extracted by mini-css-extract-plugin
module.exports = {"paper":"sample_paper__1zlJ3","page":"sample_page__1Lw-h","label":"sample_label__3lW9v","qrcode":"sample_qrcode__1niSH","desc":"sample_desc__3qPAz"};